<div class="page-content-wrapper">
  <div class="card shadow rounded-3 p-0 border-1">
    <div class="card-header bg-white border-0 mb- fw-bold">Customer Data</div>

    <div class="card-body">
      <CustomTabs
        :tabs="tabs"
        v-model="current_tab"
      />

      <!-- Profile Tab -->
      <div class="tab-content">
        <div v-if="current_tab === 'Profile'" class="tab-pane fade show active">
          <CustomerProfile
            :first_name="first_name"
            :last_name="last_name"
            :email="email"
            :phone_number="phone_number"
            :id_number="id_number"
            :date_joined="date_joined"
            :reference="reference"
            :get_user_id="get_user_id"
            :workflow_id="workflow_id"
            :customer_application="customerApplicationId"
            :credit_bureau_services="credit_bureau_services"
            :financial_services="financial_services"
            @status-changed="get_customer_data"
            @service-clicked="handleServiceClick"
          />
        </div>
      </div>

      <!-- Documents Tab -->
      <div
        v-if="current_tab === 'Documents'"
        class="tab-pane fade show active fw-bold text-xs mb-2"
      >
        <div v-if="documents.length === 0">
          This customer does not have any documents yet
        </div>
        <div v-else>
          <div v-for="document in documents" :key="document.id" class="row">
            <div class="mb-3">
              <button
                type="button"
                class="btn btn-dark text-white rounded-small text-xs fw-bold shadow text-uppercase"
                @click="toggle_iframe(document); get_document_overall_severity(document)"
              >
                {{ document.document_type }}
              </button>

              <div
                v-if="selected_document && selected_document.id === document.id"
                class="mt-3"
              >
                <!-- Risk Matrix Controls for CIPC Plus Score Documents -->
                <div v-if="document.document_type === 'cipc_plus_score'" class="mb-3">
                  <!-- Always show the button for CIPC Plus Score documents -->
                  <div class="d-flex justify-content-between mb-3 mt-3 align-items-center">
                    <span
                      v-if="document_overall_severity && document_overall_severity !== 'Unknown'"
                      :class="['badge', 'badge-xxl', 'text-xxl', 'px-4', 'py-2', 'rounded-pill', 'fw-bolder', document_severity_class]"
                    >
                      {{ document_overall_severity }} Severity
                    </span>
                    <span v-else></span>
                    <button
                      class="btn btn-primary rounded-pill shadow-sm fw-bold text-xs d-flex align-items-center"
                      @click="toggle_document_risk_matrix(document)"
                      :disabled="!cipc_plus_score_service_id"
                      :title="!cipc_plus_score_service_id ? 'Loading service data...' : 'Show Risk Assessment'"
                    >
                      <i class="fa fa-chart-bar me-2"></i>
                      <span>{{ show_document_risk_matrix ? 'Hide Risk Assessment' : 'Show Risk Assessment' }}</span>
                      <i class="fa" :class="show_document_risk_matrix ? 'fa-chevron-up ms-2' : 'fa-chevron-down ms-2'"></i>
                    </button>
                  </div>

                  <!-- Risk Matrix Component for CIPC Plus Score Documents -->
                  <RiskMatrix
                    v-if="show_document_risk_matrix && selected_document_for_risk && selected_document_for_risk.id === document.id && cipc_plus_score_service_id"
                    :service_id="cipc_plus_score_service_id"
                    service_name="CIPC Plus Score"
                    :customer_name="`${first_name} ${last_name}`"
                    :user_id="Number($route.params.id)"
                    :application_id="Number($route.params.application)"
                    service_type="service"
                    @risk-data-loaded="handle_document_risk_update"
                  />

                  <!-- Loading message if service not found -->
                  <div v-if="show_document_risk_matrix && selected_document_for_risk && selected_document_for_risk.id === document.id && !cipc_plus_score_service_id" 
                       class="alert alert-info">
                    <i class="fa fa-spinner fa-spin me-2"></i>
                    Loading risk assessment data...
                  </div>
                </div>

                <!-- Risk Matrix Controls for Experian Credit Report Documents -->
                <div v-if="document.document_type === 'experian_credit_report'" class="mb-3">
                  <!-- Always show the button for Experian Credit Report documents -->
                  <div class="d-flex justify-content-between mb-3 mt-3 align-items-center">
                    <span
                      v-if="document_overall_severity && document_overall_severity !== 'Unknown'"
                      :class="['badge', 'badge-xxl', 'text-xxl', 'px-4', 'py-2', 'rounded-pill', 'fw-bolder', document_severity_class]"
                    >
                      {{ document_overall_severity }} Severity
                    </span>
                    <span v-else></span>
                    <button
                      class="btn btn-primary rounded-pill shadow-sm fw-bold text-xs d-flex align-items-center"
                      @click="toggle_document_risk_matrix(document)"
                      :disabled="!experian_credit_report_service_id"
                      :title="!experian_credit_report_service_id ? 'Loading service data...' : 'Show Risk Assessment'"
                    >
                      <i class="fa fa-chart-bar me-2"></i>
                      <span>{{ show_document_risk_matrix ? 'Hide Risk Assessment' : 'Show Risk Assessment' }}</span>
                      <i class="fa" :class="show_document_risk_matrix ? 'fa-chevron-up ms-2' : 'fa-chevron-down ms-2'"></i>
                    </button>
                  </div>

                  <!-- Risk Matrix Component for Experian Credit Report Documents -->
                  <RiskMatrix
                    v-if="show_document_risk_matrix && selected_document_for_risk && selected_document_for_risk.id === document.id && experian_credit_report_service_id"
                    :service_id="experian_credit_report_service_id"
                    service_name="Experian Credit Report (PDF)"
                    :customer_name="`${first_name} ${last_name}`"
                    :user_id="Number($route.params.id)"
                    :application_id="Number($route.params.application)"
                    service_type="service"
                    @risk-data-loaded="handle_document_risk_update"
                  />

                  <!-- Loading message if service not found -->
                  <div v-if="show_document_risk_matrix && selected_document_for_risk && selected_document_for_risk.id === document.id && !experian_credit_report_service_id" 
                       class="alert alert-info">
                    <i class="fa fa-spinner fa-spin me-2"></i>
                    Loading risk assessment data...
                  </div>
                </div>

                <div class="ratio ratio-1x1">
                  <iframe
                    class="w-100 border-0"
                    :src="selected_document.content"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Audit Trail Tab -->
      <div v-if="current_tab === 'AuditTrail'" class="tab-pane fade show active">
        <AuditTrail
          :workflow_id="workflow_id"
          :audit_trails="audit_trails"
        />
      </div>

      <!-- Employee Screening Tab -->
      <div v-if="current_tab === 'EmployeeScreening'" class="tab-pane fade show active">
        <EmployeeScreeningData
          :customer_id="get_user_id"
          :workflow_id="get_workflow_id"
        />
      </div>

      <!-- Service Completed Tab -->
      <div class="tab-content" v-if="current_tab === 'ServiceCompleted'">
        <SlideTabComponent
          :tabs="sub_tabs"
          v-model="current_sub_tab"/>

        <div class="tab-content mt-3">
          <!-- Credit Bureau Tab Content -->
          <div v-if="current_sub_tab === 'CreditBureau'" class="mb-3">
            <!-- Loader -->
              <div v-if="is_service_loading" class="loading-container d-flex justify-content-center align-items-center">
              <div class="text-center">
                <div class="loading-spinner mb-3">
                  <i class="fa fa-spinner fa-spin fa-2x"></i>
                </div>
                <p class="loading-text">Loading...</p>
              </div>
            </div>
            <!-- No Data Message Card -->
              <div class="card shadow-sm border my-4 rounded-3"
                v-else-if="!is_service_loading && (!all_credit_bureau_services || all_credit_bureau_services.length === 0)">
                <div class="card-body d-flex flex-column justify-content-center align-items-center p-4">
                <i class="bi bi-info-circle-fill text-info fs-3 mb-3"></i>
                <p class="mb-0 text-xs text-center text-muted">
                    <b>Credit Bureau</b> service information is not currently available.
                </p>
              </div>
            </div>
            <!-- Data Table -->
            <div v-else>
              <div
                v-for="service in all_credit_bureau_services"
                :key="service.id || service.service_id"
                class="service-section"
              >
                <button
                  class="btn bg-dark text-white rounded-small fw-bold text-xs shadow-sm mb-2 d-flex align-items-center w-100 py-3"
                  @click="get_service_overall_severity(service.service_id); toggle_service(service.service_name)"
                >
                  <span class="me-2">{{ service.service_name }}</span>
                  <span class="ms-auto"><i class="fa fa-chevron-down"></i></span>
                </button>

                <div
                  v-if="active_credit_bureau_service === service.service_name"
                  class="dropdown-content"
                >
                  <!-- Risk Matrix Controls for Credit Bureau Services -->
                  <div  v-if="overall_severity !== 'Unknown'" class="d-flex justify-content-between mb-3 mt-3 align-items-center">
                    <span
                      :class="['badge', 'badge-xxl', 'text-xxl', 'px-4', 'py-2', 'badge', 'rounded-pill', 'px-3', 'py-1', 'rounded-pill', 'fw-bolder', severity_class]"
                    >
                      {{overall_severity}} Severity
                    </span>
                    <button
                      class="btn btn-primary rounded-pill shadow-sm fw-bold text-xs d-flex align-items-center"
                      @click="toggle_risk_matrix(service)"
                    >
                      <i class="fa fa-chart-bar me-2"></i>
                      <span>{{ show_risk_matrix ? 'Hide Risk Assessment' : 'Show Risk Assessment' }}</span>
                      <i class="fa" :class="show_risk_matrix ? 'fa-chevron-up ms-2' : 'fa-chevron-down ms-2'"></i>
                    </button>
                  </div>

                  <!-- Risk Matrix Component for Credit Bureau Services -->
                  <RiskMatrix
                    v-if="show_risk_matrix && selected_service_for_risk && selected_service_for_risk.id === service.id"
                    :service_id="service.service_id"
                    :service_name="service.service_name"
                    :customer_name="`${first_name} ${last_name}`"
                    :user_id="$route.params.id"
                    :application_id="$route.params.application"
                    service_type="service"
                    @update="handle_risk_update"
                  />
                  <div
                    v-if="canRerunService(service)"
                    class="dropdown-content"
                  >
                    <RerunService
                      :service_data="service"
                      :workflow_id="workflow_id"
                      @rerun-success="handleRerunSuccess(service)"
                    />
                  </div>

                  <div v-else-if="service.response && Object.keys(service.response).length > 0">                    
                    <!-- Service Content -->
                    <AddressVerificationReport
                      v-if="service.service_name === 'Address Match'"
                      :address_data="service.response"
                    />

                    <CreditReport
                      v-else-if="service.service_name === 'Experian Credit Report (PDF)'"
                      :credit_data="service.response"
                    />

                    <IncomeEstimatorReport
                      v-else-if="service.service_name === 'Income Estimator'"
                      :income_data="service.response"
                    />
                    <IncomePredictorReport
                      v-else-if="service.service_name === 'Income Predictor'"
                      :income_predictor_data="service.response"
                    />
                    <ReportViewer
                      v-else-if="service.service_name === 'Individual Liveness Verification'"
                      service_type="individual_liveness"
                      :response_doc="service.response_doc"
                      title="Individual Liveness Verification Report"
                      :export_data="service.response"
                    >
                      <IndividualLivenessReport
                        :individual_liveness_data="service.response"
                      />
                    </ReportViewer>
                    <ReportViewer
                      v-else-if="service.service_name === 'Enterprise Credit Check'"
                      service_type="enterprise_credit"
                      :response_doc="service.response_doc"
                      title="Enterprise Credit Report"
                      :export_data="service.response"
                    >
                      <CompanyCreditReport
                        :customer_credit_data="service.response"
                      />
                    </ReportViewer>

                      <ReportViewer
                      v-else-if="service.service_name === 'Telephones'"
                      service_type="telephones"
                      :response_doc="service.response_doc"
                      title="Telephones"
                      :export_data="service.response"
                    >
                    </ReportViewer>

                      <ReportViewer
                        v-else-if="service.service_name === 'Alternative Liveness Verification'"
                        service_type="alternative_liveness"
                        :response_doc="service.response_doc"
                        title="Alternative Liveness Verification Report"
                        :export_data="service.response"
                      >
                        <AlternativeLivenessReport :verification_data="service.response" />
                      </ReportViewer>

                    <div
                      v-else-if="service.service_name === 'Anti Money Laundering'"
                    >
                      <ReportViewer
                        :response_doc="service.response_doc"
                        title="Anti-Money Laundering Report"
                        service_type="aml"
                        :export_data="service.response"
                      >
                        <AMLReport
                          :aml_data="aml_results(service.response)"
                          :response_info="response_info_aml(service.response)"
                          :date_scored="date_scored(service.response)"
                        />
                      </ReportViewer>
                    </div>

                    <div
                      v-else-if="service.service_name === 'Enterprise Anti Money Laundering'"
                    >
                      <ReportViewer
                        service_type="enterprise_aml"
                        :response_doc="service.response_doc"
                        title="Enterprise Anti Money Laundering Report"
                        :export_data="service.response"
                      >
                        <EnterpriseAmlVerificationReport
                          :aml_data="service.response"
                        />
                      </ReportViewer>
                    </div>

                    <div v-else-if="service.service_name === 'Enterprise KYB'">
                      <EnterpriseKYBReport :kyb_data="service.response" />
                    </div>

                    <div
                      v-else-if="service.service_name === 'OCR verification'"
                    >
                      <ReportViewer
                        service_type="ocr_verification"
                        :response_doc="service.response_doc"
                        title="OCR Verification Report"
                        :export_data="service.response"
                      >
                        <OcrVerificationReport
                          :ocr_verification_data="service.response"
                        />
                      </ReportViewer>
                    </div>

                    <div
                      v-else-if="service.service_name === 'OCR Liveness Verification'"
                    >
                      <ReportViewer
                        :response_doc="service.response_doc"
                        title="OCR Liveness Verification Report"
                        service_type="ocr_liveness"
                        :export_data="service.response"
                      >
                        <OcrLivenessVerificationReport
                          :ocr_liveness_data="service.response"
                        />
                      </ReportViewer>
                    </div>

                    <div
                      v-else-if="service.service_name === 'ID Verification (Liveness check)'"
                    >
                      <ReportViewer
                        service_type="id_liveness_verification"
                        :response_doc="service.response_doc"
                        title="ID Verification Report"
                        :export_data="service.response"
                      >
                        <IdVerificationReport
                          :id_liveness_data="service.response"
                          :customer_image="customer_image_base_64"
                        />
                      </ReportViewer>
                    </div>

                    <div
                      v-else-if="service.service_name === 'Refugee Verification'"
                    >
                      <RefugeeVerificationReport
                        :refugee_verification_data="service.response"
                        :customer_image="customer_image_base_64"
                      />
                    </div>

                    <div
                      v-else-if="service.service_name === 'RSA ID Verification'"
                    >
                      <ReportViewer
                        service_type="rsa_id_verification"
                        :response_doc="service.response_doc"
                        title="RSA ID Verification Report"
                        :export_data="service.response"
                      >
                        <RsaIdVerificationReport
                          :rsa_id_data="service.response"
                          :customer_image="customer_image_base_64"
                        />
                      </ReportViewer>
                    </div>

                    <div
                      v-else-if="service.service_name === 'Eligibility Solution'"
                    >
                      <EligibilitySolutionReport
                        :eligibility_data="service.response"
                      />
                    </div>

                    <div
                      v-else-if="service.service_name === 'Online Bank Statements' || service.service_name === 'Manual Bank Statement Upload'"
                    >
                      <BankStatementVerificationReport
                        :bank_statement_data="service.response"
                      />
                    </div>
                    <div
                      v-else-if="service.service_name === 'All in One Bank Statement Retrieval'"
                    >
                      <AllInOneBankVerificationReport
                        :all_in_one_data="service.response"
                      />
                    </div>
                    <div
                      v-else-if="service.service_name === 'Bank Account Individual Verification'"
                    >
                      <IndividualBankAccountReport
                        :bank_account_data="service.response"
                      />
                    </div>

                    <!-- add component for `Director Screening`, which have the same results and RSA ID Verification and AML() -->
                    <div
                      v-else-if="service.service_name === 'Director Screening'"
                    >
                      <DirectorScreeningReport
                        :bank_account_data="service.response"
                      />
                    </div>

                    <div
                      v-else-if="service.service_name === 'Bank Account Company Verification'"
                    >
                      <CompanyBankAccountReport
                        :company_account_data="service.response"
                      />
                    </div>

                    <div v-else-if="service.service_name === 'Trust Search'">
                      <TrustSearchReport
                        :trust_search_data="trust_data[0].trust_data"
                      />
                    </div>

                    <div
                      v-else-if="service.service_name === 'Mastercard MATCH Pro Inquiry'"
                    >
                      <MastercardReport :mastercard_data="service.response" />
                    </div>
                    <ReportViewer
                      v-else-if="service.service_name === 'Comprehensive Liveness Verification'"
                      service_type="comprehensive_liveness"
                      :response_doc="service.response_doc"
                      title="Comprehensive Liveness Verification Report"
                      :export_data="service.response"
                    >
                      <ComprehensiveLivenessVerificationReport
                        :comprehensive_liveness_data="service.response"
                      />
                    </ReportViewer>

                    <ReportViewer
                      v-else-if="service.service_name?.toLowerCase().includes('credit report namibia')"
                      :response_doc="namibia_pdf_url(service.response)"
                      title="Credit Report Namibia"
                    >
                      <div class="alert alert-info text-xs">
                        <i class="fas fa-spinner fa-spin me-2"></i>
                        Document is being generated. Please wait...
                      </div>
                    </ReportViewer>

                    <div
                      v-else-if="service.service_name === 'Academic Post 92 Check'"
                    >
                      <AcademicPost92CheckReport
                        :academic_post92_data="service.response"
                      />
                    </div>
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table table-bordered">
                      <tbody>
                        <template
                          v-for="(item, index) in preprocess_data(service.response, '', service.service_name)"
                          :key="index"
                        >
                          <tr v-if="item.type === 'heading'">
                            <th class="table-secondary py-2 text-s" :colspan="2">
                              {{ format_label(item.label) }}
                            </th>
                          </tr>

                          <tr v-else-if="item.type === 'input' || item.type === 'label'">
                            <td class="col-3">
                              <span class="fw-bold text-xs me-2">{{ format_label(item.label) }}</span>
                            </td>
                            <td class="col-9">
                              <span v-if="item.value || item.value === 0" class="text-xs" :class="{
                                'text-success fw-bold': item.key && item.key.includes('document_authenticity') && item.value === 1 && format_label(item.label) !== 'Pages Count',
                                'text-danger fw-bold': item.key && item.key.includes('document_authenticity') && item.value === 0 && format_label(item.label) !== 'Pages Count',
                                'text-warning fw-bold': item.key && item.key.includes('document_authenticity') && item.value === 2 && format_label(item.label) !== 'Pages Count'
                              }">{{ format_label(item.label) === 'Pages Count' ? item.value : format_auth_value(item) }}</span>
                              <span v-else class="text-muted text-xs">None</span>
                            </td>
                          </tr>

                          <template v-else-if="item.type === 'custom_table'">
                            <tr>
                              <th class="table-dark text-white text-s" :colspan="item.headers.length">
                                {{ format_label(item.table) }}
                              </th>
                            </tr>
                            <tr>
                              <th
                                v-for="header in item.headers"
                                :key="header"
                                class="text-xxs bg-gray text-start"
                              >
                                {{ header }}
                              </th>
                            </tr>
                            <tr
                              v-for="(row, rowIndex) in item.rows"
                              :key="rowIndex"
                            >
                              <td class="text-xxs text-start">{{ row.productId }}</td>
                              <td class="text-xxs text-start">{{ row.score }}</td>
                              <td class="text-xxs text-start">{{ row.sourceId }}</td>
                              <td class="text-xxs text-start">{{ row.category }}</td>
                              <td class="text-xxs text-start">{{ row.country }}</td>
                              <td class="text-xxs text-start">{{ row.sentimentConfidenceLevel }}</td>
                              <td class="text-xxs text-start">{{ row.subjectMatched }}</td>
                              <td class="text-xxs text-start">
                                {{ row.highlights }}
                                <p>{{ row.url }}</p>
                              </td>
                            </tr>
                          </template>

                          <template v-else-if="item.type === 'images' && item.images.length">
                            <tr>
                              <td :colspan="2" class="text-center py-3">
                                <label class="form-label text-s fw-bold mb-3 d-block">
                                  {{ item.label }}
                                </label>
                                <div class="d-flex justify-content-center align-items-center gap-3 mx-auto">
                                  <div
                                    v-for="(image, i) in item.images"
                                    :key="i"
                                    class="image-container text-center"
                                  >
                                    <p class="text-dark small mb-2">{{ image.label }}</p>
                                    <img
                                      :src="image.src"
                                      class="facial-image img-fluid rounded shadow-sm"
                                      :alt="image.label"
                                    />
                                  </div>
                                  <div v-if="customer_image" class="image-container">
                                    <p class="text-dark small mb-2">Customer Image</p>
                                    <img
                                      :src="customer_image"
                                      class="facial-image img-fluid rounded shadow-sm"
                                      alt="Customer Facial Image"
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </template>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="current_sub_tab === 'background_screening'" class="mb-3">
            <!-- Academic Check Management -->
            <div class="mb-3">
              <AcademicCheckManagement :customerApplicationId="get_customer_application_id" />
            </div>
            <!-- Huru Criminal Check Management -->
            <div class="mb-3">
              <HuruCriminalCheckManagement :customerApplicationId="get_customer_application_id" />
            </div>
          </div>

          <!-- System Generated Tab Content -->
          <div v-if="current_sub_tab === 'SystemGenerated'" class="mb-3">
            <!-- Loader -->
            <div v-if="is_service_loading" class="loading-container d-flex justify-content-center align-items-center">
              <div class="text-center">
                <div class="loading-spinner mb-3">
                  <i class="fa fa-spinner fa-spin fa-2x"></i>
                </div>
                <p class="loading-text">Loading...</p>
              </div>
            </div>
            <!-- No Data Message Card -->
              <div class="card shadow-sm border my-4 rounded-3"
                v-else-if="!is_service_loading && (!system_generated_services.services || system_generated_services.services.length === 0)">
                <div class="card-body d-flex flex-column justify-content-center align-items-center p-4">
                <i class="bi bi-info-circle-fill text-info fs-3 mb-3"></i>
                <p class="mb-0 text-xs text-center text-muted">
                    <b>System Generated</b> service information is not currently available.
                </p>
              </div>
            </div>
            <!-- Data Table -->
            <div v-else>
              <div
                v-for="service in system_generated_services.services"
                :key="service.id"
                class="service-section"
              >
                <button
                  class="btn bg-dark text-white rounded-small fw-bold text-xs shadow-sm mb-2 d-flex align-items-center w-100 py-3"
                  @click="get_overall_severity(service.id); toggle_service(service.service_name)"
                >
                  <span class="me-2">{{ format_label(service.service_name) }}</span>
                  <span class="ms-auto"><i class="fa fa-chevron-down"></i></span>
                </button>

                <div v-if="active_system_generated_service === service.service_name">
                  <div v-if="overall_severity !== 'Unknown'" class="d-flex justify-content-between mb-3 mt-3 align-items-center">
                    <span
                      :class="['badge', 'badge-xxl', 'text-xxl', 'px-4', 'py-2', 'badge', 'rounded-pill', 'px-3', 'py-1', 'rounded-pill', 'fw-bolder', severity_class]"
                    >
                      {{overall_severity}} Severity
                    </span>
                    <button
                      class="btn btn-primary rounded-pill shadow-sm fw-bold text-xs d-flex align-items-center"
                      @click="toggle_risk_matrix(service)"
                    >
                      <i class="fa fa-chart-bar me-2"></i>
                      <span>{{ show_risk_matrix ? 'Hide Risk Assessment' : 'Show Risk Assessment' }}</span>
                      <i class="fa" :class="show_risk_matrix ? 'fa-chevron-up ms-2' : 'fa-chevron-down ms-2'"></i>
                    </button>
                    <button
                      class="btn btn-primary rounded-pill shadow-sm fw-bold text-xs d-flex align-items-center"
                      @click="download_custom_form(service)"
                    >
                      <i class="fa fa-download me-2"></i>
                      <span>Download</span>
                    </button>
                  </div>
                  <div v-else class="d-flex justify-content-between mb-3 mt-3 align-items-center">
                    <button
                      class="btn btn-primary rounded-pill shadow-sm fw-bold text-xs d-flex align-items-center"
                      @click="download_custom_form(service)"
                    >
                      <i class="fa fa-download me-2"></i>
                      <span>Download</span>
                    </button>
                  </div>

                  <RiskMatrix
                    v-if="show_risk_matrix && selected_service_for_risk && selected_service_for_risk.id === service.id"
                    :service_id="service.id"
                    :service_name="service.service_name"
                    :customer_name="`${first_name} ${last_name}`"
                    :user_id="$route.params.id"
                    :application_id="$route.params.application"
                    service_type="custom_form"
                    @update="handle_risk_update"
                  />

                  <div class="row" :class="{'g-4': Object.keys(service.questions).length > 3}">
                    <div
                      v-for="question in service.questions"
                      :key="question"
                      class="col-md-6 mt-4 mb-2"
                    >
                      <label class="form-label text-xs fw-bold">{{ question.question }}</label>
                      <div v-if="question.response && (
                        question.response.startsWith('https://s3.af-south-1.amazonaws.com/') || 
                        question.response.includes('.pdf') || 
                        question.question_type === 'File'
                      )">
                        <button
                          type="button"
                          class="btn btn-dark text-white rounded-small text-xs shadow text-uppercase"
                          @click="show_document(question.response)"
                        >
                          View Document
                        </button>
                        <div v-if="selected_document_url === question.response" class="mt-3">
                          <iframe
                            :src="question.response"
                            class="w-100 border-0 iframe-style"
                          ></iframe>
                        </div>
                      </div>
                      <div v-else-if="Array.isArray(format_questions(question.response))">
                        <div
                          v-for="(item, index) in format_questions(question.response)"
                          :key="index"
                          class="mb-2"
                        >
                          <input
                            type="text"
                            class="form-control text-xs rounded-small p-3 shadow-sm"
                            :value="item"
                            readonly
                          />
                        </div>
                      </div>

                      <div v-else-if="question.question_type === 'Text Area'">
                        <textarea
                          :class="['form-control' ,'text-xs', 'rounded-small' ,'p-3', 'shadow-sm', 'textarea-auto-height']"
                          :value="question.response"
                          readonly
                          rows="6"
                        ></textarea>
                      </div>

                      <div v-else>
                        <input
                          type="text"
                          class="form-control text-xs rounded-small p-3 shadow-sm"
                          :value="question.response"
                          readonly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
